
import Vue from "vue";
import { FormsAndSurveyServices } from "@/services";
import config from "@/config";
export default Vue.extend({
  data() {
    return {
      loadingThemes: false,
      deleteInProgress: false,
      themeList: [] as { _id: string; name: string; surveyId: string }[],
    };
  },
  methods: {
    async getAllThemes() {
      try {
        this.loadingThemes = true;
        const { data } = await FormsAndSurveyServices.getThemeListSurveys({
          locationId: config.themeLocation,
        });
        this.themeList = data.themes;
        this.loadingThemes = false;
      } catch (error) {
        console.log(error);
        this.themeList = [];
        this.loadingThemes = false;
      }
    },
    async deleteTheme(themeId: any) {
      try {
        this.deleteInProgress = true;
        await FormsAndSurveyServices.deleteThemeInSurveys(themeId);
        this.deleteInProgress = false;
        await this.getAllThemes();
      } catch (error) {
        console.error(error);
        this.deleteInProgress = false;
      }
    },
  },
});
